export const GET_ITEM_INGREDIANTS = "GET_ITEM_INGREDIANTS"
export const GET_ITEM_INGREDIANTS_SUCCESS = "GET_ITEM_INGREDIANTS_SUCCESS"
export const GET_ITEM_INGREDIANTS_FAIL = "GET_ITEM_INGREDIANTS_FAIL"

